export default __webpack_public_path__ + "4065c6a67b1d61a31ca537d0435f7627.png";